import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { OtherPlaceTextComponent } from 'src/app/_components/remote-action-step/other-place-text/other-place-text.component';
import { PlaceType } from 'src/app/_model/placetype';

@Injectable()
export class OtherPlaceTextRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return OtherPlaceTextComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    if (currentData && currentData.selected_pt === PlaceType.PLACE_TEXT && (currentData.destinationInfo == undefined || currentData.destinationInfo == "Sonstiges Ziel")) {
      return true;
    } else {
      return false;
    }
  }
}
